// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6064) return "js/6064-b4d8497180ca1133d8cc.chunk.js";
	if (chunkId === 2875) return "js/2875-22620d930f60f199017c.chunk.js";
	if (chunkId === 2011) return "js/2011-81f9ca95d9988c5af73e.chunk.js";
	if (chunkId === 4392) return "js/4392-c5647f19cbd069253458.chunk.js";
	if (chunkId === 4960) return "js/4960-5e116d71c899e98204b4.chunk.js";
	if (chunkId === 1398) return "js/permission-1bcbc2d2255eb5f6483c.chunk.js";
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"222":"d22bf9fa4ecf0cac4b75","271":"7b42efaba89af44836a1","1232":"d3970329a790d5f2dee3","2152":"4db4d0a77be064b5d683","2237":"c8fc2ab496dd91693c7a","5345":"13be9eafa2283274ac2d","5353":"df5b481e620e49d5b9c3","7685":"977be8c873fe952ea27c"}[chunkId] + ".js";
};